import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
  {
    accessor: "type_name_id",
    header: "Quality Check Type",
    cell: (row) => <>{row?.type_name?.qc_batch ? row?.type_name?.qc_batch?.type_name : "-"}</>,
  },
  {
    accessor: "minimum_lot_size",
    header: "Minimum Lot Size",
  },
  {
    accessor: "maximum_lot_size",
    header: "Maximum Lot Size",
  },
  {
    accessor: "sample_size",
    header: "Sample Size",
  },
  {
    accessor: "code_letter",
    header: "Code Letter",
  },
  {
    accessor: "critical_threshold",
    header: "Critical Threshold",
  },
  {
    accessor: "major_threshold",
    header: "Major Threshold",
  },
  {
    accessor: "minor_threshold",
    header: "Minor Threshold",
  },
];

const SamplingPlan = () => {
  const privileges = secureLocalStorage.getItem("privileges");
  const navigate = useNavigate();
  const [samplingPlanEntries, setSamplingPlanEntries] = useState(5);
  const [samplingPlanPageIndex, setSamplingPlanPageIndex] = useState(0);
  const [search, setSearch] = useState("");

  const { useFetch } = useAPIQuery({
    key: "sampling_plan",
    endpoint: "/api/sampling-plan/",
  });

  const { data, isLoading } = useFetch({
    params: {
      entries: samplingPlanEntries,
      page_no: samplingPlanPageIndex + 1,
      event: search ? search : undefined,
    },
    abortOnNewRequest: true,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 3,
    retry: 3,
    keepPlaceholder: true,
    refetchOnReconnect: true,
  });

  const { useDelete } = useAPIQuery({
    key: "sampling_plan",
    endpoint: "/api/sampling-plan/",
  });

  const { mutate: deleteData } = useDelete();

  const handleGlobalFilterChange = (value) => {
    setSearch(value);
  };

  const handlePagination = (value) => {
    console.log(value);
    setSamplingPlanPageIndex(value.pageIndex);
    setSamplingPlanEntries(value.pageSize);
  };

  const handleEditRow = (row) => {
    console.log(row);
    navigate("/edit-sampling-plan", { state: { editpost: row.original } });
  };

  const handleDeleteRow = (row) => {
    console.log(row);
    const entry_id = row.original.id;
    Swal.fire({
      text: "Are you sure? You will not be able to recover this data!",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No, cancel!`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData({ id: entry_id });
      }
    });
  };

  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <div className="nk-block-head-content d-flex">
            <h3 className="nk-block-title page-title">Sampling Plan</h3>
            {isLoading ? (
              <div className="spinner-border text-primary ms-2" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              ""
            )}
          </div>
          {privileges.includes("sampling_plan_create") && (
            <div className="nk-block-head-content">
              <NavLink
                to="/sampling-plan-check"
                className="toggle btn btn-icon btn-primary d-md-none"
                id="button-button-sampling-plan-check"
              >
                <em className="icon ni ni-plus"></em>
              </NavLink>

              <NavLink
                to="/sampling-plan-check"
                className="toggle btn btn-primary d-none d-md-inline-flex"
                id="button-button-sampling-plan-check"
              >
                <em className="icon ni ni-plus"></em>
                <span>Create Sampling Plan</span>
              </NavLink>
            </div>
          )}
        </div>
      </div>

      <Table
        data={data ? data.results.data : []}
        columns={columns}
        pagination
        pageIndex={samplingPlanPageIndex}
        pageSize={samplingPlanEntries}
        rowCount={data ? data.count : 0}
        globalSearch
        editRows={
          privileges.includes("sampling_plan_update") ? true : false
        }
        deleteRows={
          privileges.includes("sampling_plan_delete") ? true : false
        }
        filterModal={false}
        selectRows={false}
        onGlobalFilterChange={handleGlobalFilterChange}
        onRowEdit={handleEditRow}
        onRowDelete={handleDeleteRow}
        onPaginationChange={handlePagination}
      />
    </>
  );
};

export default SamplingPlan;